<template>
    <div class="quiz-layout">
        <section class="layout layout-scale layout-scale-join-page" :class="{ 'opacity-0': !isAlreadyShow }">
            <div class="header text-center">
                <HeaderLogo
                    :warning-message="$t('playlive_alert_leave')"
                    logoWidth="20"
                    color="var(--ui-color)"
                    shadow="var(--question-shadow-color)"
                    class="logo inline-block"
                ></HeaderLogo>
            </div>
            <div class="content">
                <div class="content-container h-full poll" v-if="type == 'poll'">
                    <PollSummary :quiz-image="image" :title="title" :summary.sync="summary"></PollSummary>
                </div>
                <div class="content-container" v-if="type == 'quiz' && quizSummary.length > 0">
                    <QuizSummary
                        :player-name="name"
                        :quiz-image="image"
                        :title="title"
                        :summary.sync="quizSummary"
                        :winner-name="winnerName"
                        :quizzes="quizzes"
                        @ended="showCoinAnimation()"
                        @show-player-list="showPlayerList = true"
                    ></QuizSummary>
                </div>
            </div>
            <div class="footer">
                <div class="block md:hidden">
                    <div class="flex items-center justify-center">
                        <button
                            @click="handleClickFinish"
                            id="end-btn"
                            class="theme-button btn btn-large uppercase font-size-22 font-opensans"
                        >
                            {{
                                $t('playlive_summary_button_end', {
                                    type:
                                        type != 'quiz' ? $t('playlive_share_type_poll') : $t('playlive_share_type_quiz')
                                })
                            }}
                        </button>
                        <button
                            v-if="orderAbility.can_download_report"
                            class="theme-button ml-2 btn btn-large uppercase font-size-22 font-opensans"
                            @click="openModal"
                        >
                            <i class="fas fa-download text-2xl"></i>
                        </button>
                    </div>
                </div>

                <!-- Begin Desktop Footer -->
                <div class="hidden md:block">
                    <div class="text-center">
                        <button
                            @click="handleClickFinish"
                            id="end-btn"
                            class="theme-button btn btn-large uppercase font-size-22 font-opensans"
                        >
                            {{
                                $t('playlive_summary_button_end', {
                                    type:
                                        type != 'quiz' ? $t('playlive_share_type_poll') : $t('playlive_share_type_quiz')
                                })
                            }}
                        </button>
                        <span v-if="orderAbility.can_download_report">
                            <a
                                @click="openModal"
                                class="theme-button ml-2 btn btn-large uppercase font-size-22 font-opensans shadow-text-none"
                                >{{ $t('playlive_summary_button_report') }}
                            </a>
                        </span>
                    </div>
                    <!-- <button @click="handleClickFinish" style="top: 0; right: -45px;" class="absolute btn btn-large text-white text-3xl uppercase">Finish</button> -->
                </div>
                <!-- End Desktop Footer -->
            </div>
        </section>

        <div>
            <TopRightMenu
                :login-status="loginStatus"
                @click-your-quiz-link="clickToMyQuiz()"
                @click-new-quiz="clickNewQuiz()"
                @click-edit-profile="clickEditProfile()"
                @click-order="clickOrder()"
                @click-subscribe-plan="clickSubscribePlan()"
                @click-subpage="clickSubpage"
                @click-buy-credit="clickBuyCredit()"
                @open-auth-popup="showAuthPopup = true"
            />
            <AuthPopup
                v-if="showAuthPopup"
                ref="authPopup"
                :webview-redirect-to="createWebviewRedirectTo()"
                @login-success="loginSuccess"
                @register-success="loginSuccess"
                @close="showAuthPopup = false"
            />
        </div>

        <CoinContainer v-if="isShowCoinContainer" :totalCoin="totalCoin" @ended="isShowCoinContainer = false" />

        <download-report-popup
            :open="isOpen"
            :file="this.file"
            :downloadReport="this.downloadReport"
            :sendToDrive="this.sendToDrive"
            @close="closeModal"
        />

        <PlayerResultList v-if="showPlayerList" :result="reports" @close="showPlayerList = false" />
    </div>
</template>

<script>
import PollSummary from '@/components/PollSummary.vue'
import QuizSummary from '@/components/QuizSummary.vue'
import DownloadReportPopup from '@/components/DownloadReportPopup'
import { mapGetters, mapState } from 'vuex'
import answer from '@/lib/answer.js'
import popup from '@/lib/popup.js'
import HeaderLogo from '@/components/HeaderLogo.vue'
import ResizeScale from '@/lib/resize-scale.js'
import quizReportMixins from '@/mixins/quiz-report'
import AuthPopup from '@/components/AuthPopup'
import AuthPopupMixin from '@/mixins/auth-popup'
import CoinContainer from '@/components/CoinContainer'
import TopRightMenu from '@/components/TopRightMenu'
import { isLoggedIn } from '@/lib/user.js'
import socketConnectionMixin from '@/mixins/socket-connection.js'
import PlayerResultList from '@/components/PlayerResultList.vue'

export default {
    mixins: [quizReportMixins, AuthPopupMixin, socketConnectionMixin],

    sockets: {
        user_answered_result: function (data) {
            if (this.type == 'poll') {
                this.summary = answer.summarizePollAnswer(data.result, this.questions)
            }

            if (this.type == 'quiz') {
                this.quizSummary = answer.summarizeQuiz(data.result, data.users)

                this.reports = {
                    score: this.quizSummary,
                    type: 'quiz',
                    users: data.users,
                    result: data.result,
                    quiz: {
                        id: this.id,
                        title: this.title,
                        image: this.image
                    },
                    questions: this.questions
                }

                this.winnerName = this.$t('playlive_summary_no_winner')

                if (this.quizSummary[0] && this.quizSummary[0].score > 0) {
                    this.winnerName = this.quizSummary[0].name
                }

                if (this.orderAbility.can_download_report) {
                    this.downloadReport()
                }
            }
        }
    },

    components: {
        PollSummary,
        QuizSummary,
        HeaderLogo,
        TopRightMenu,
        AuthPopup,
        CoinContainer,
        DownloadReportPopup,
        PlayerResultList
    },

    data: function () {
        return {
            summary: [],
            quizSummary: [],
            winnerName: '',
            countUserResult: 0,
            isShowCoinContainer: false,
            componentsAlreadyCount: 0,
            isAlreadyShow: false,
            isOpen: false,
            isClickEnd: false,
            showPlayerList: false
        }
    },

    mounted: function () {
        window.onbeforeunload = function () {
            return 'Are you sure you want to leave this page? You will loose any unsaved actions'
        }

        // this.$store.commit('updateRemoveAppPaddingX', false)

        this.checkMasterActive()

        this.$socket.emit('user_waiting_result', {
            type: this.type,
            room: this.code
        })

        if (isLoggedIn() && this.totalCoin > 0) {
            this.$store.dispatch('saveCoin', this.totalCoin).then(() => {
                this.$store.dispatch('getCredit')
            })
        }

        // Receive custom event componentAlready
        window.addEventListener('componentAlready', () => {
            if (this.$route.name === 'summary') {
                this.componentsAlreadyCount++

                if (this.componentsAlreadyCount == 2) {
                    this.resizeScaleQuizFrame()
                }
            }
        })
    },

    destroyed() {
        window.onbeforeunload = function () {}
    },

    methods: {
        openModal: function () {
            this.isOpen = true
        },

        closeModal: function () {
            this.isOpen = false
        },

        handleClickFinish: function () {
            if (this.isAllowToPressNext) {
                document.querySelector('#end-btn').style.pointerEvents = 'none'
            }

            if (this.isClickEnd) {
                return
            }

            this.isClickEnd = true

            if (this.isMasterPlayer) {
                this.$socket.emit('master_press_play_again', {
                    room: this.code
                })
            }

            this.$router.replace({
                name: 'thanks'
            })
        },

        resizeScaleQuizFrame() {
            const contentElem = document.getElementsByClassName('content-container')[0]
            const layoutElem = document.getElementsByClassName('layout')[0]
            const headerElem = document.getElementsByClassName('header')[0]
            const footerElem = document.getElementsByClassName('footer')[0]
            const footerHeight = footerElem.getBoundingClientRect().height
            const headerHeight = headerElem.getBoundingClientRect().height
            const uselessHeight = headerHeight + footerHeight

            layoutElem.style.setProperty('--useless-h', `${uselessHeight}px`)

            new ResizeScale({
                width: contentElem.getBoundingClientRect().width,
                height: contentElem.getBoundingClientRect().height,
                child: contentElem,
                parent: layoutElem,
                uselessHeight: uselessHeight,
                noTransForm: false
            })

            document.getElementById('app').classList.add('overflow-hidden')
            document.getElementById('app').classList.add('relative')
            this.countUserResult++

            this.isAlreadyShow = true
        },

        showCoinAnimation() {
            if (this.totalCoin <= 0) {
                return false
            }

            this.isShowCoinContainer = true
        }
    },

    computed: {
        ...mapState({
            id: state => state.player.quiz._id,
            name: state => state.player.name,
            questions: state => state.cacheQuestions || state.player.quiz.questions,
            title: state => state.player.quiz.title,
            type: state => state.player.quiz.type,
            code: state => state.player.quiz.code,
            quizzes: state => state.player.quiz,
            image: state => state.player.quiz.image,
            isMasterPlayer: state => state.player.isMasterPlayer,
            orderAbility: state => state.orderAbility,
            isMuted: state => state.isMuted
        }),

        ...mapGetters({
            totalCoin: 'player/totalCoin',
            playerSound: 'player/getPlayerSound'
        })
    },

    beforeRouteLeave(to, from, next) {
        window.onbeforeunload = function () {}

        if (to.name === 'thanks') {
            next()
        } else {
            next(false)
            popup.confirm(
                this.$t('playlive_alert_leave'),
                function () {
                    window.location.href = '/join'
                },
                function () {
                    window.onbeforeunload = function () {
                        return 'Are you sure you want to leave this page? You will loose any unsaved actions'
                    }
                }
            )
        }
    }
}
</script>

<style lang="scss" scoped>
.logo {
    @media (max-width: 767px) {
        display: inline-block;
        width: 10rem;
    }
}

.mute-btn {
    top: 30px;
    right: 70px;
}

.not-logIn {
    top: 21px;
}

.layout {
    height: calc(100vh - 2rem);
    height: calc((var(--vh, 1vh) * 100) - 2rem);
}

.btn {
    padding: 0.6rem 1.5rem;
}

@media screen and (min-width: 768px) and (max-width: 1920px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
}

@media screen and (max-width: 767px) {
    section.layout .content {
        overflow: hidden;
        height: calc(100% - var(--useless-h));
    }
    section.layout .footer {
        bottom: 0;
    }
    .content-container.poll {
        overflow-y: auto;
    }

    .mute-btn {
        top: 21px;
        right: 64px;
    }

    .not-logIn {
        top: 11px;
    }
}

@media screen and (max-width: 575px) {
    .mute-btn {
        top: 64px;
        right: 20px;
    }

    .not-logIn {
        right: 13px;
    }
}
</style>
